<app-visitor-card-details
  [identity]="identity"
  [visitorCardStubs]="recentVisitorCards"
></app-visitor-card-details>

<div
  class="card card-nc"
  *ngIf="hasEntitlement('VISITORS_ADJUSTMENTS_BALANCE_TRANSFER')"
>
  <form #xferForm="ngForm" name="balanceTransferForm" novalidate>
    <div class="card-heading">
      <div class="col-md-5 zeroPadding float-left">
        <i class="fa fa-exchange"></i
        ><span class="cardHeaderHeading"> BALANCE TRANSFER </span>
      </div>
      <span class="float-right save-card"
        ><button
          *ngIf="transferStarted"
          type="button"
          class="btn cancel-btn"
          (click)="cancel()"
        >
          CANCEL
        </button>
        &nbsp;&nbsp;
        <button
          *ngIf="transferStarted"
          type="button"
          class="btn btn-nc"
          (click)="balanceTransfer()"
        >
          CONFIRM
        </button>
        <button
          *ngIf="!transferStarted"
          type="button"
          class="btn btn-nc"
          (click)="startTransfer()"
        >
          TRANSFER
        </button>
      </span>
    </div>
    <div class="card-body">
      <div class="row labelCommon text-nowrap">
        <div class="form-group col-md-3 col-centered accountBorder">
          <div class="row col-centered">
            <button
              type="button"
              class="inline col-centered col-md-5"
              [ngClass]="dColor"
              (click)="creditDebit('D')"
            >
              <i [ngClass]="debitCheckCircle"></i> DEBIT
            </button>
            <button
              type="button"
              class="inline col-centered col-md-5"
              [ngClass]="cColor"
              (click)="creditDebit('C')"
            >
              <i [ngClass]="creditCheckCircle"> </i> CREDIT
            </button>
          </div>
          <div class="row">&nbsp;</div>
        </div>
        <div class="form-group col-md-2 zeroPadding col-centered">
          <div class="row">
            <label class="col-centered col-md-12 text-nowrap" for="srcAcct">
              <!-- {{creditDebitChip}}-->Chip Account</label
            >
          </div>
          <div class="row">
            <div
              *ngIf="visitorCard"
              class="col-centered col-md-12 text-nowrap staticText1"
            >
              {{ visitorCard.chipAccount }}
            </div>
          </div>
        </div>
        <div class="form-group col-md-1 zeroPadding">
          <div class="row col-centered zeroPadding" [ngClass]="dArrow">
            <i class="fa fa-long-arrow-right fa-2x"></i>
          </div>
          <div class="row  col-centered zeroPadding" [ngClass]="cArrow">
            <i class="fa fa-long-arrow-left fa-2x"></i>
          </div>
        </div>
        <div class="form-group col-md-3 col-left accountBorder">
          <div class="row">
            <label for="desAcct" class="col-md-12 col-centered">
              <!-- {{creditDebitDisbo}}-->
              Disbo Account
            </label>
          </div>
          <div class="row">
            <div class="col-md-12  col-left staticText1">
              <select
                class="form-control input-sm"
                id="disboAccount"
                name="disboAccount"
                [(ngModel)]="disboAccount"
                required
              >
                <option
                  *ngFor="let disbo of disboAccounts"
                  [value]="disbo.account"
                  >{{ disbo.description }}</option
                >
              </select>
            </div>
          </div>
        </div>
        <div class="form-group col-md-3 zeroPadding col-centered">
          <div class="row">
            <label for="xferAmt" class="col-centered col-md-12 text-nowrap"
              >Transfer Amount</label
            >
          </div>
          <div class="row">
            <div
              [ngClass]="{ 'has-error': xfer.invalid && xfer.dirty }"
              class="col-centered col-md-12 staticText1"
            >
              <input
                type="text"
                class="form-control input-sm"
                [ngClass]="{ 'has-error': xfer.invalid && xfer.dirty }"
                id="xferAmt"
                [(ngModel)]="xferAmt"
                name="xferAmt"
                placeholder="0.00"
                style="width:50%;margin-left: 50pt"
                pattern="^(\d{1,8}\.\d{1,2}|\d+)$"
                maxlength="10"
                required
                #xfer="ngModel"
                #xferAmount
              />
              <span
                *ngIf="xfer.invalid && xfer.touched && xfer.errors?.required"
                class="has-error validationMessage"
              >Required</span>
              <span
                *ngIf="xfer.invalid && xfer.dirty && !xfer.errors?.required"
                class="has-error validationMessage"
              >
                Invalid
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="card-heading" *ngIf="transferSummary">
    BALANCE TRANSFER DETAILS
  </div>
  <div
    class="whiteCardRow labelBlue"
    *ngIf="transferSummary"
    document-click="clearActionTips($event)"
  >
    <div class="row">
      <label class="col-md-4">&nbsp;</label>
      <label class="col-md-4 control-label labelBlueBold"> Source </label>
      <label class="col-md-4 control-label labelBlueBold"> Destination </label>
    </div>
    <div class="row borderLine">
      <label class="col-md-4 labelCommon">Client Account Number</label>
      <div class="col-md-4 staticText3">{{ transferSummary.srcClntAcct }}</div>
      <div class="col-md-4 staticText3">{{ transferSummary.desClntAcct }}</div>
    </div>
    <div class="row borderLine">
      <label class="col-md-4 labelCommon"> Account Number </label>
      <div class="col-md-4 staticText3">{{ transferSummary.srcAcct }}</div>
      <div class="col-md-4 staticText3">{{ transferSummary.desAcct }}</div>
    </div>
    <div class="row borderLine">
      <label class="col-md-4 labelCommon"> Account Holder Name </label>
      <div class="col-md-4 staticText3">{{ transferSummary.srcName }}</div>
      <div class="col-md-4 staticText3">{{ transferSummary.desName }}</div>
    </div>
    <div class="row borderLine">
      <label class="col-md-4 labelCommon"> SSN </label>
      <div class="col-md-4 staticText3">{{ transferSummary.srcSsn4 }}</div>
      <div class="col-md-4 staticText3">{{ transferSummary.desSsn4 }}</div>
    </div>
    <div class="row borderLine">
      <label class="col-md-4 labelCommon"> Amount Transferred </label>
      <div class="col-md-8 staticText3">
        {{ transferSummary.amount | currency }}
      </div>
    </div>
    <div class="row">
      <label class="col-md-4 labelCommon"> Current Balance </label>
      <div class="col-md-4 staticText3">
        {{ transferSummary.srcBal | currency }}
      </div>
      <div class="col-md-4 staticText3">
        {{ transferSummary.desBal | currency }}
      </div>
    </div>
  </div>
</div>
